<template>
  <div class="page_ blue_">
    <div class="content">
      <div class="item_p" v-for="(item, index) in list2" :key="index">
        <p>{{ item.tit }}</p>
        <div class="item_a" v-for="(item1, ind) in item.list" :key="ind">
          <span class="circle_"></span>
          <span>{{ item1.tit }}</span>
          <a :href="item1.link" target="_blank">{{
            $t("InsuranceInfo[30]") || "下载"
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  data() {
    return {
      list: [
        {
          tit: this.$t("fileList[4]"),
          list: [
            {
              tit: this.$t("fileList[0]"),
              link:
                "http://provider.medilink-global.com.cn/中间带事先授权申请表.pdf"
            },
            {
              tit: this.$t("fileList[2]"),
              link:
                "http://provider.medilink-global.com.cn/中间带会员事后理赔申请单.pdf"
            }
          ]
        },
        {
          tit: this.$t("fileList[5]"),
          list: [
            {
              tit: this.$t("fileList[7]"),
              link:
                this.$i18n.locale == "zh-cn"
                  ? "http://provider.medilink-global.com.cn/member portal会员操作手册.pdf"
                  : "http://provider.medilink-global.com.cn/memberportal 英文版操作指南.pdf"
            }
          ]
        }
      ],
      list1: [
        {
          tit: this.$t("fileList[4]"),
          list: [
            {
              tit: this.$t("fileList[1]"),
              id: "MGU",
              link:
                "http://provider.medilink-global.com.cn/MGU事先授权申请表.pdf"
            },
            {
              tit: this.$t("fileList[3]"),
              id: "MGU",
              link:
                "http://provider.medilink-global.com.cn/MGU会员事后理赔申请单.pdf"
            }
          ]
        },
        {
          tit: this.$t("fileList[5]"),
          list: [
            {
              tit: this.$t("fileList[7]"),
              link:
                this.$i18n.locale == "zh-cn"
                  ? "http://provider.medilink-global.com.cn/member portal会员操作手册.pdf"
                  : "http://provider.medilink-global.com.cn/memberportal 英文版操作指南.pdf"
            }
          ]
        }
      ],
      list2: [
        {
          tit: this.$t("fileList[4]"),
          list: [
            {
              tit: this.$t("fileList[0]"),
              link:
                "http://provider.medilink-global.com.cn/中间带事先授权申请表.pdf"
            },
            {
              tit: this.$t("fileList[2]"),
              link:
                "http://provider.medilink-global.com.cn/中间带会员事后理赔申请单.pdf"
            }
          ]
        },
        {
          tit: this.$t("fileList[5]"),
          list: [
            {
              tit: this.$t("fileList[7]"),
              link:
                this.$i18n.locale == "zh-cn"
                  ? "http://provider.medilink-global.com.cn/member portal会员操作手册.pdf"
                  : "http://provider.medilink-global.com.cn/memberportal 英文版操作指南.pdf"
            }
          ]
        }
      ]
    };
  },
  mounted() {
    api
      .showEmployeeInfo()
      .then(res => res.data)
      .then(data => {
        let employeeInfo = data.data.filter(item => item.isMainCard == "0")[0];
        if (employeeInfo.is_mgu == "Y") {
          this.list2 = JSON.parse(JSON.stringify(this.list1));
        } else {
          this.list2 = JSON.parse(JSON.stringify(this.list));
        }
        this.$CardList(data.data);
      });
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.page_ {
  position: relative;
  background-color: #fff;
  height: auto;
  overflow: hidden;
  padding: 0 27px 0 27px;
  border-radius: 10px;
  color: #394155;
  height: 100%;
  .content {
    padding-bottom: 17px;
    .item_p {
      margin-bottom: 20px;

      > p {
        font-weight: bold;
        color: #394155;
        margin-bottom: 17px;
        font-size: 16px;
        border-bottom: 1px solid #f3f3f3;
        padding: 17px 0;
      }
      .item_a {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .circle_ {
          width: 4px;
          height: 4px;
          max-width: 4px;
          background-color: #2c5acc;
          border-radius: 4px;
          display: inline-block;
          margin-right: 5px;
        }
        span:nth-child(2) {
          font-size: 14px;
          color: #394155;
          margin-right: 10px;
        }
        a {
          color: #2c5acc;
          font-size: 12px;
          &:hover {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>